import {
    Emoji,
    EmojiText,
} from '@gagovictor/shared-frontend-core/dist/shared/components/Emoji';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from '@mui/material';
import React from 'react';

import { MessageKey, useT } from '../../i18n';
import { StreakStatus } from '../streak';

interface Props {
    open: boolean;
    onClose: () => void;
    streak: number;
    status: StreakStatus;
}

/** Explains the streak. It deliberately says nothing about getting a lost streak back: that is a surprise. */
export const StreakDialog: React.FC<Props> = ({
    open,
    onClose,
    streak,
    status,
}) => {
    const t = useT();
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                <Box component="span" sx={{ flex: 1, fontWeight: 800 }}>
                    {t('streak.title')}
                </Box>
                <IconButton onClick={onClose} aria-label={t('streak.close')}>
                    <CloseRoundedIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ textAlign: 'center', mb: 2 }}>
                    <Box sx={{ display: 'grid', placeItems: 'center' }}>
                        <Emoji emoji="🔥" size={56} />
                    </Box>
                    <Typography variant="h5" sx={{ fontWeight: 800 }}>
                        {t('streak.days', { count: streak })}
                    </Typography>
                    <Typography color="text.secondary" sx={{ mt: 0.5 }}>
                        <EmojiText>
                            {t(`streak.status.${status}` as MessageKey)}
                        </EmojiText>
                    </Typography>
                </Box>
                <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 800, opacity: 0.8, mb: 0.5 }}
                >
                    {t('streak.how.title')}
                </Typography>
                {(['1', '2', '3'] as const).map((n) => (
                    <Typography key={n} variant="body2" sx={{ mb: 0.75 }}>
                        • {t(`streak.how.${n}` as MessageKey)}
                    </Typography>
                ))}
            </DialogContent>
        </Dialog>
    );
};
